
import { useRef, useEffect } from "react";
import { disposeSafe } from "../fable_modules/fable-library-js.5.3.0/Util.js";
import { iterate } from "../fable_modules/fable-library-js.5.3.0/Seq.js";
import { some, toArray } from "../fable_modules/fable-library-js.5.3.0/Option.js";
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.3.0/FSharp.Core.js";

/**
 * Native <dialog> modal: opened once the dialog element is mounted. `openKey` changes when it opens.
 */
export function useShowModal(dialogRef, openKey) {
    const dependencies = [openKey];
    useEffect(() => {
        const setup = (() => {
        let d;
        let disp;
        const matchValue = dialogRef.current;
        let matchResult, d_1;
        if (matchValue != null) {
            if ((d = matchValue, !d.open)) {
                matchResult = 0;
                d_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                d_1.showModal();
                break;
            }
        }
        disp = {
            Dispose() {
            },
        };
        return () => {
            let copyOfStruct = disp;
            disposeSafe(copyOfStruct);
        };
    })();
        return setup;
        }, dependencies);;
}

/**
 * Every close path returns focus to the trigger.
 */
export function useReturnFocusOnClose(triggerRef, isOpen) {
    const wasOpen = useRef(false);
    const dependencies = [isOpen];
    useEffect(() => {
        const setup = (() => {
        let disp;
        if (wasOpen.current && !isOpen) {
            iterate((t) => {
                t.focus();
            }, toArray(triggerRef.current));
        }
        wasOpen.current = isOpen;
        disp = {
            Dispose() {
            },
        };
        return () => {
            let copyOfStruct = disp;
            disposeSafe(copyOfStruct);
        };
    })();
        return setup;
        }, dependencies);;
}

/**
 * Ref callback that stores the element, or None when React detaches it.
 */
export function refSetter(r, el) {
    r.current = (Operators_IsNull(el) ? undefined : some(el));
}

//# sourceMappingURL=ModalDialog.js.map
